export const SET_MODAL_WINDOW_DATA = 'SET_MODAL_WINDOW_DATA';
export const CLOSE_MODAL_WINDOW = 'CLOSE_MODAL_WINDOW';



// WEBPACK FOOTER //
// ./src/modules/App/redux/constants/modalWindow.constants.js